import Vue from "vue";
import Vuex from "vuex";

// import axios from "axios";
// import AppConfig from "../../../AppConfig";
// import NODE_ENV from "../../../env";

// const baseURL = AppConfig[NODE_ENV]["apiGatewayBookings"];

Vue.use(Vuex);

export default {
  state: {
    shipConsolidationID: null,
    consolidations: [],
    newConsolidationLevel: 1,
    newConsolidationSelecetedRoutes: [],
    newConsolidationSelecetedShipment: []
  },
  getters: {
    getShipConsolidationID: (state) => {
      return state.shipConsolidationID;
    },
    getNewConsolidationLevel: (state) => {
      return state.newConsolidationLevel;
    },
    getNewConsolidationSelecetedRoute: (state) => {
      return state.newConsolidationSelecetedRoutes;
    },
    getNewConsolidationSelecetedShipment: (state) => {
      return state.newConsolidationSelecetedShipment;
    },
  },
  mutations: {
    SHIP_CONSOLIDATION_ID(state, payload) {
      state.shipConsolidationID = payload;
    },
    SET_CONSOLIDATIONS(state, payload) {
      state.consolidations = payload
    },
    SET_CONSOLIDATIONS_LEVEL(state, payload) {
      state.newConsolidationLevel = payload
    },
    SET_RESET_NEW_CONSOLIDATION(state) {
      state.newConsolidationLevel = 1;
      state.newConsolidationSelecetedRoutes = [];
      state.newConsolidationSelecetedShipment = []
    },
    SET_NEW_CONSOLIDATION_SELECETED_ROUTES(state, payload) {
      state.newConsolidationSelecetedRoutes = payload
    },
    SET_NEW_CONSOLIDATION_SELECETED_SHIPMENT(state, payload) {
      state.newConsolidationSelecetedShipment = payload
    }
  },
  actions: {
    setShipConsolidationID({ commit }, payload) {
      // console.log(payload);
      commit("SHIP_CONSOLIDATION_ID", payload);
    },
    setConsolidations({ commit }, payload) {
      commit("SET_CONSOLIDATIONS", payload)
    },
    setNewConsolidationLevel({ commit }, payload) {
      commit("SET_CONSOLIDATIONS_LEVEL", payload)
    },
    setResetConsolidation({ commit }, payload) {
      commit("SET_RESET_NEW_CONSOLIDATION", payload)
    },
    setNewConsolidationSelecetedRoutes({ commit }, payload) {
      commit("SET_NEW_CONSOLIDATION_SELECETED_ROUTES", payload)
    },
    setNewConsolidationSelecetedShipment({ commit }, payload) {
      commit("SET_NEW_CONSOLIDATION_SELECETED_SHIPMENT", payload)
    },
  },
};
